import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  property: null,
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyProperty: (state, data) => {
      state.property = data.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCompanyProperty } = companySlice.actions;

export default companySlice.reducer;
